import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_layout/ai")({
  beforeLoad: async () => {
    throw redirect({ to: "/conversations" });
  },
  component: AiRedirect,
});

function AiRedirect() {
  return null;
}
